import styled from 'styled-components';

/**
 * The two cards side by side, with the gaps the Owner / Agents / Services
 * row uses, so the screen keeps one rhythm; stacked on a phone.
 */
export const CardsGrid = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  margin-bottom: 24px;

  @media (max-width: 800px) {
    grid-template-columns: minmax(0, 1fr);
    gap: 8px;
  }
`;
